export default {
    MAINTENANCE_DOMAIN: "https://test.maintenance.akuvox.com",
    BASE_LOG_URI: "wss://test.maintenance.akuvox.com/devlog_data",
    ENV: [
        {id: "ucloud",      name: "美国云"},
        {id: "ecloud",      name: "欧洲云"},
        {id: "ecloud-tis",  name: "欧洲云-tis"},
        {id: "scloud",      name: "新加坡云"},
        {id: "jcloud",      name: "日本云"},
        {id: "ccloud",      name: "中国云"},
        {id: "aucloud",     name: "澳洲云"},
        {id: "rucloud",     name: "俄罗斯云"},
        {id: "ucloud_dr",   name: "美国云-容灾"},
        {id: "dev",         name: "开发环境"},
        {id: "test",        name: "测试环境-aws"},
        {id: "test84",      name:"test84"},
        {id: "dev_smarthome_test",    name:"dev_smarthome_test"},
        {id: "sacloud",     name:"沙特云"},
        {id: "t-healthcare",name:"t-healthcare"},
        {id: "test_kyy",    name:"test_kyy"},
        {id: "dev_sh",      name:"dev_sh"},
        {id: "dev_hz",      name:"开发环境-杭州"},
        {id: "azcloud",     name:"阿塞拜疆"},
        {id: "discreet",    name:"印度云"},
        {id: "discreet2025",name:"印度云-2025"},
        {id: "test_hager",  name:"test_hager"}
    ],

    
}
